import { useState } from 'react';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';
import { TrustedUrlsSettings } from './settings/TrustedUrlsSettings';
import { GraphSettings } from './settings/GraphSettings';
import * as styles from '../styles/components/settings-modal.css';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type TabId = 'security' | 'graph';

interface Tab {
  id: TabId;
  label: string;
}

const TABS: Tab[] = [
  { id: 'security', label: 'Security' },
  { id: 'graph', label: 'Graph' },
  // 将来の拡張用
  // { id: 'general', label: 'General' },
  // { id: 'appearance', label: 'Appearance' },
];

/**
 * アプリケーション設定モーダル
 */
export function SettingsModal({ isOpen, onClose }: SettingsModalProps) {
  const [activeTab, setActiveTab] = useState<TabId>('security');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'security':
        return <TrustedUrlsSettings />;
      case 'graph':
        return <GraphSettings />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Settings"
      width="lg"
      data-testid="settings-modal"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className={styles.container}>
        {TABS.length > 1 && (
          <div className={styles.tabs}>
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {renderTabContent()}
      </div>
    </Dialog>
  );
}
